<template>
  <div class="dialog" :class="{ 'active' : showDialog }">
    <div class="dialog--content u-extra-large-padding--top">
      <template v-if="message">
        <p>{{ message }}</p>
      </template>
      <div class="text-center u-extra-medium-margin--bottom">
        <v-page-loading v-show="isLoading" />
        <a class="button" :disabled="isLoading" :href="pdfUrl" target="_blank">{{ $t('download') }}</a>
        <div v-if="pdfError">
          <p>Fehler bei der PDF-Erzeugung</p>
        </div>
      </div>
      <button class="close-button" v-on:click.prevent="onCloseDialog()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
  </div>
</template>

<script>
import PageLoading from "./../partials/PageLoading";

export default {
  name: "ProjectPdfDialog",
  components: {
    vPageLoading: PageLoading
  },
  props: {
    isVisible: {
      type: Boolean,
      default: false
    },
    projectId: {
      type: Number,
      default: 0
    },
    projectNumber: {
      type: String,
      default: ""
    }
  },
  model: {
    prop: "showDialog",
    event: "showchange"
  },
  data() {
    return {
      message: "",
      isLoading: true,
      pdfUrl: "#",
      pdfError: false
    };
  },

  computed: {
    showDialog: {
      get: function() {
        if (this.isVisible) {
          this.onOpenDialog();
        }
        return this.isVisible;
      },
      set: function(value) {
        this.$emit("showchange", value);
      }
    }
  },
  methods: {
    onOpenDialog: function() {
      this.generatePdf();
      this.showDialog = true;
    },
    onCloseDialog: function() {
      this.showDialog = false;
    },
    generatePdf: function() {
      this.isLoading = true;
      this.pdfError = false;
      this.pdfUrl = "#";
      this.message = this.$t("project.pdf.generate_message", {
        project_number: this.projectNumber
      });
      let promise = this.$api
          .clearParams()
          .get("projects/" + this.projectId + "/pdf");
      return promise
          .then(
              function(response) {
                this.pdfUrl =
                    response.data.data.url;
              }.bind(this)
          )
          .catch(
              function(error) {
                this.pdfError = true;
                window.app.$helpers.logger(
                    "PDF Link was not given in the response"
                );
              }.bind(this)
          )
          .finally(
              function() {
                this.isLoading = false;
              }.bind(this)
          );
    }
  }
};
</script>